import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import SelectedLegComponent from '../components/SelectedLegComponent';
import { RangeComponent } from '../..';
import { PlannerValidation } from './PlannerValidation';
/**
 * Platsa and eket frames have two different floor connectors. One for the low leg and one for the high legs.
 * This validation handles that the frame only can snap to the connector for the current selected
 * leg that is stored in the SelectedLegComponent.
 */
export class LegsValidation extends PlannerValidation {
    constructor(coreApi, defaultLegProductRef, range) {
        super(coreApi, 'LegsValidation');
        this.FLOOR_CONNECTOR_KEYS = ['floor-connector-low-legs', 'floor-connector-high-legs'];
        this.defaultLegProductRef = defaultLegProductRef;
        this.range = range;
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        if (!this.isEnabled ||
            !this.FLOOR_CONNECTOR_KEYS.includes(snapActionCandidate.guestConnector.key)) {
            return this.validationOK();
        }
        const entity = snapActionCandidate.guestRoot;
        if (this.range && !this.isRange(entity, this.range)) {
            return this.validationOK();
        }
        const scene = this.coreApi.entities.getScene();
        const leg = scene?.getComponent(SelectedLegComponent.id)?.coreProductId ||
            this.defaultLegProductRef;
        return snapActionCandidate.guestConnector.tags().includes(leg)
            ? this.validationOK()
            : this.validationFail('Can´t snap to this connector for selected leg');
    }
    isRange(entity, range) {
        if (entity.hasComponent(ComponentIds.AUTOMATIC_ENTITY_GROUP_COMPONENT_ID)) {
            const groupChildren = HierarchyUtils.children(entity);
            return !!groupChildren.find(child => child.getComponent(RangeComponent.id)?.range === range);
        }
        return entity.getComponent(RangeComponent.id)?.range === range;
    }
}
//# sourceMappingURL=LegsValidation.js.map